
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/join-as-a-healer",
      function () {
        return require("private-next-pages/join-as-a-healer.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/join-as-a-healer"])
      });
    }
  